import angular from 'angular';
import template from './htmlelement.html';
import fbtemplate from './builder/preview.html';

const htmlElementConfig = /* @ngInject */ (/** @type {any}} */ KformComponentsProvider) => {
	KformComponentsProvider.register('htmlelement', {
		title:        'HTML Element',
		template,
		selectable:   true,
		settings:     {
			key:       'html',
			label:     'Content',
			hideLabel: true,
			input:     false,
			tag:       'p',
			attrs:     [],
			className: '',
			content:   '',
		},
		fbtemplate,
		icon:         'fa fa-code',
		views:        [
			{
				name:     'Display',
				template: 'kform/components/htmlelement/display.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
		],
	});
};

export default angular.module('app').config(htmlElementConfig);
